import { createQueryKeys } from 'utils/react-query-utils';

export const seatsKeys = createQueryKeys('seats', (createKey) => ({
  single: (seatId: string) => createKey(seatId),
  multiple: (companyId: string) => createKey(companyId),
  orderFormDocument: (seatId: string) =>
    createKey('order-form', seatId, 'document'),
}));
